/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable react/no-array-index-key */
import {
  AppBar,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
/**
 * FAQ component define here.
 * @returns
 */
const FAQView = () => {
  const rows = Array.from({ length: 2 }, () => ({}));

  //
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{ height: 75, maxHeight: 75, padding: 0, margin: 0 }}
    >
      <Grid container spacing={2} direction="row" m={10}>
        <Grid m={10} item container justifyContent="space-between">
          <Typography variant="h2" gutterBottom color="black">
            Frequently Asked Questions
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Questions</TableCell>
                  <TableCell>Answers</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((_, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {Array.from({ length: 2 }, (e, colIndex) => (
                      <TableCell key={colIndex} />
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </AppBar>
  );
};
//
export default FAQView;
